import React, { useState } from 'react';

import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack';

import { useGlobal } from '../../contexts/Global/context';

import Icon from '../Icons';

import * as S from './styles';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function FileViewer({ children, fileExtension, src, base64, ...rest }) {
    const { contrastTheme } = useGlobal();

    const [totalPages, setTotalPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setTotalPages(numPages);
    }

    function changePage(newPage) {
        if (newPage > 0 && newPage <= totalPages) setPageNumber(newPage);
    }

    return fileExtension === 'pdf' ? (
        <S.PdfContainer>
            <Document file={`data:application/pdf;base64,${base64}`} onLoadSuccess={onDocumentLoadSuccess}>
                <Page pageNumber={pageNumber} />
            </Document>
            <div className="arrow-container">
                <div onClick={() => changePage(pageNumber - 1)}>
                    <Icon name="ArrowLeft" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                </div>
                <p>
                    Página {pageNumber} de {totalPages}
                </p>
                <div onClick={() => changePage(pageNumber + 1)}>
                    <Icon name="ArrowRight" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                </div>
            </div>
        </S.PdfContainer>
    ) : (
        <S.ImageContainer>
            <S.StyledImg alt="frame-img" src={src} {...rest} />
        </S.ImageContainer>
    );
}

export default FileViewer;
